"use client";

import { useEffect } from "react";

const ScrollReset = () => {
  useEffect(() => {
    // Prevent browser from restoring scroll position on refresh
    window.history.scrollRestoration = "manual";
    // Always start at the top
    window.scrollTo(0, 0);
  }, []);

  return null;
};

export default ScrollReset;
